import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TagsTable } from "./tags-table";
import { TagCategoriesTable } from "./tag-categories-table";

export function TagsManagement() {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Tags Management</h1>
      </div>

      <Tabs defaultValue="tags" className="w-full">
        <TabsList>
          <TabsTrigger value="tags">Tags</TabsTrigger>
          <TabsTrigger value="categories">Categories</TabsTrigger>
        </TabsList>

        <TabsContent value="tags" className="mt-4">
          <TagsTable />
        </TabsContent>

        <TabsContent value="categories" className="mt-4">
          <TagCategoriesTable />
        </TabsContent>
      </Tabs>
    </div>
  );
}
